export function isnotnullornotundefined(value:string):boolean{
    return (value !=  null || value !== undefined) ? true: false;
}
